<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12 mb-3>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700">
          USER
        </h2>
        <v-breadcrumbs class="px-0" :items="breadcrumbs"></v-breadcrumbs>
      </v-flex>
      <v-card>
        <v-card-title>
          <v-flex xs9>
            {{ id ? 'Edit User' : 'Create New User' }}
          </v-flex>
          <v-flex xs3 class="text-right">
            <v-icon title="refresh" @click="getData()">refresh</v-icon>
          </v-flex>
        </v-card-title>
        <ValidationObserver ref="obs">
          <v-form @submit.prevent="save" class="pa-5">
            <v-layout row wrap>
              <v-flex xs6 py-0>
                <ValidationProvider
                  name="NIK"
                  rules="required"
                  v-slot="{ errors, valid }"
                >
                  <label class="darkblue--text">NIK</label>
                  <v-text-field
                    id="nik"
                    single-line
                    outlined
                    placeholder="NIK"
                    dense
                    v-model="items.nik"
                    type="number"
                    required
                    data-vv-name="nik"
                    :error-messages="errors"
                    :success="valid"
                  ></v-text-field>
                </ValidationProvider>
              </v-flex>
              <v-flex xs6 py-0>
                <ValidationProvider
                  name="Name"
                  rules="required"
                  v-slot="{ errors, valid }"
                >
                  <label class="darkblue--text">Name</label>
                  <v-text-field
                    id="name"
                    single-line
                    outlined
                    placeholder="Name"
                    dense
                    v-model="items.name"
                    type="text"
                    required
                    data-vv-name="name"
                    :error-messages="errors"
                    :success="valid"
                  ></v-text-field>
                </ValidationProvider>
              </v-flex>
              <v-flex xs6 py-0>
                <ValidationProvider
                  name="Email"
                  rules="required|email"
                  v-slot="{ errors, valid }"
                >
                  <label class="darkblue--text">Email</label>
                  <v-text-field
                    id="email"
                    single-line
                    outlined
                    placeholder="Email"
                    dense
                    v-model="items.email"
                    type="email"
                    required
                    data-vv-name="email"
                    :error-messages="errors"
                    :success="valid"
                  ></v-text-field>
                </ValidationProvider>
              </v-flex>
              <v-flex xs6 py-0>
                <ValidationProvider
                  name="Password"
                  :rules="!id ? 'required' : ''"
                  v-slot="{ errors, valid }"
                >
                  <label class="darkblue--text">Password</label>
                  <v-text-field
                    id="password"
                    single-line
                    outlined
                    dense
                    :disabled="!!id"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="show1 = !show1"
                    :type="show1 ? 'text' : 'password'"
                    placeholder="Password"
                    v-model="items.password"
                    :required="!id"
                    data-vv-name="password"
                    :error-messages="errors"
                    :success="valid"
                  ></v-text-field>
                </ValidationProvider>
              </v-flex>
              <v-flex xs12 py-0>
                <v-checkbox
                  v-model="items.is_login_optima"
                  label="Allow Login with Optima"
                  color="menuActive"
                  required
                  class="mt-0"
                  style="margin-left: -5px"
                >
                </v-checkbox>
              </v-flex>
              <v-flex xs12 py-0>
                <ValidationProvider
                  name="Profile"
                  rules="required"
                  v-slot="{ errors, valid }"
                >
                  <label class="darkblue--text">Profile</label>
                  <v-autocomplete
                    id="profile"
                    single-line
                    outlined
                    placeholder="Select Profile"
                    dense
                    v-model="items.profiles"
                    required
                    multiple
                    :items="profiles"
                    item-text="desc"
                    return-object
                    :error-messages="errors"
                    :success="valid"
                  ></v-autocomplete>
                </ValidationProvider>
              </v-flex>
            </v-layout>
            <!-- <h4>Add Profile</h4>
            <v-layout
              row
              wrap
              v-for="(profile, index) in items.profiles"
              :key="index"
            >
              <v-flex xs2>
                <ValidationProvider
                  name="profile"
                  rules="required"
                  v-slot="{ errors, valid }"
                >
                  <label class="darkblue--text">Profile</label>
                  <v-autocomplete
                    id="profile"
                    single-line
                    outlined
                    placeholder="Select Profile"
                    v-model="profile.profile"
                    required
                    :items="profiles"
                    item-value="name"
                    item-text="name"
                    :error-messages="errors"
                    :success="valid"
                  ></v-autocomplete>
                </ValidationProvider>
              </v-flex>
              <v-flex xs2>
                <ValidationProvider
                  name="profile"
                  rules="required"
                  v-slot="{ errors, valid }"
                >
                  <label class="darkblue--text">Role</label>
                  <v-autocomplete
                    id="role"
                    single-line
                    outlined
                    placeholder="Select Role"
                    v-model="profile.role"
                    required
                    :items="roles"
                    :error-messages="errors"
                    :success="valid"
                  ></v-autocomplete>
                </ValidationProvider>
              </v-flex>
              <v-flex xs3>
                <ValidationProvider
                  name="division"
                  rules="required"
                  v-slot="{ errors, valid }"
                >
                  <label class="darkblue--text">Division</label>
                  <v-autocomplete
                    id="division"
                    single-line
                    outlined
                    placeholder="Select Division"
                    v-model="profile.division_id"
                    required
                    :items="divisions"
                    item-value="id"
                    item-text="name"
                    :error-messages="errors"
                    :success="valid"
                  ></v-autocomplete>
                </ValidationProvider>
              </v-flex>
              <v-flex xs3>
                <ValidationProvider
                  name="division"
                  rules="required"
                  v-slot="{ errors, valid }"
                >
                  <label class="darkblue--text">House</label>
                  <v-autocomplete
                    id="house"
                    single-line
                    outlined
                    placeholder="Select House"
                    v-model="profile.house_id"
                    required
                    :items="houses"
                    item-value="id"
                    item-text="name"
                    :error-messages="errors"
                    :success="valid"
                  ></v-autocomplete>
                </ValidationProvider>
              </v-flex>
              <v-flex xs2 class="mt-8">
                <v-icon
                  id="button-add"
                  @click="addProfile()"
                  color="secondblue"
                >
                  add_circle_outline
                </v-icon>
                <v-icon
                  v-if="index > 0"
                  id="button-remove"
                  @click="removeProfile(index)"
                  color="red"
                  class="ml-3"
                >
                  delete
                </v-icon>
              </v-flex>
            </v-layout> -->
            <v-card-actions class="text-right pr-0">
              <v-spacer></v-spacer>
              <v-flex xs2 right class="mr-4">
                <v-btn
                  id="button-cancel"
                  dark
                  rounded
                  color="red"
                  block
                  :to="{ name: 'user' }"
                >
                  Cancel
                </v-btn>
              </v-flex>
              <v-flex xs2 right>
                <v-btn
                  id="button-save"
                  dark
                  rounded
                  color="blue darken-3"
                  block
                  @click="save"
                >
                  Save
                </v-btn>
              </v-flex>
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-card>
    </v-container>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import ProgressDialog from '../../../components/progress_dialog';

export default {
  $_veeValidate: {
    validator: 'new'
  },
  components: { 'progress-dialog': ProgressDialog },
  props: ['id'],
  data() {
    return {
      loading: true,
      progressDialogLoading: true,
      search: '',
      show1: false,
      breadcrumbs: [
        {
          text: 'User Management',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'User',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: this.id ? 'Edit' : 'Create',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      items: {
        nik: null,
        name: '',
        email: '',
        password: '',
        profiles: [],
        is_login_optima: false
      },
      profiles: [],
      roles: ['Superadmin', 'Inputter', 'Approver', 'Viewer', 'Verificator'],
      departments: [],
      houses: [],
      divisions: []
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // addProfile() {
    //   this.items.profiles.push({
    //     profile: null,
    //     role: null,
    //     division_id: null,
    //     house_id: null
    //   });
    // },
    // removeProfile(index) {
    //   this.items.profiles.splice(index, 1);
    // },
    async getData() {
      this.getProfile();
      this.items = {
        nik: null,
        name: '',
        email: '',
        password: '',
        profiles: []
      };
      requestAnimationFrame(() => {
        this.$refs.obs.reset();
      });
      if (this.id) {
        this.getDetail();
      }
    },
    getProfile() {
      this.progressDialogLoading = true;
      this.loading = true;
      this.$store
        .dispatch('auth/listProfile')
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data) {
            this.profiles = data.data.result;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          console.log(err.response);
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    getDetail() {
      this.progressDialogLoading = true;
      this.loading = true;
      const id = this.id;
      this.$store
        .dispatch('auth/detail', { id })
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.items = data.data;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          console.log(err.response);
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    async save() {
      const validated = await this.$refs.obs.validate();
      if (validated) {
        this.progressDialogLoading = true;
        this.loading = true;
        let profile = this.items.profiles.map(item => {
          return item.id;
        });
        if (this.id) {
          let param = {
            nik: this.items.nik,
            name: this.items.name,
            email: this.items.email,
            // password: this.items.password,
            profileIds: profile,
            is_login_optima: this.items.is_login_optima
          };
          this.$store
            .dispatch('auth/update', { id: this.id, params: param })
            .then(data => {
              this.progressDialogLoading = false;
              this.loading = false;
              if (data.code === 200) {
                Swal.fire('Success!', data.message.text_en, 'success');
                this.$router.push({
                  name: 'user'
                });
              } else {
                Swal.fire(
                  'Failed!',
                  data.response.data.message.text_en,
                  'error'
                );
              }
            })
            .catch(err => {
              console.log('error', err);
              Swal.fire('Failed!', err.response.data.message.text_en, 'error');
              this.progressDialogLoading = false;
              this.loading = false;
            });
        } else {
          let param = {
            nik: this.items.nik,
            name: this.items.name,
            email: this.items.email,
            password: this.items.password,
            profilesIds: profile,
            is_login_optima: this.items.is_login_optima
          };
          this.$store
            .dispatch('auth/create', param)
            .then(data => {
              this.progressDialogLoading = false;
              this.loading = false;
              if (data.code === 200) {
                Swal.fire('Success!', data.message.text_en, 'success');
                this.$router.push({
                  name: 'user'
                });
              } else {
                Swal.fire(
                  'Failed!',
                  data.response.data.message.text_en,
                  'error'
                );
              }
            })
            .catch(err => {
              console.log('error', err.response);
              this.progressDialogLoading = false;
              this.loading = false;
              Swal.fire('Failed!', err.response.data.data.error, 'error');
            });
        }
      }
    }
  }
};
</script>
